<div class="m-portlet__body" *ngIf="data">
	<div class="form-group m-form__group row">
		<label for="example-text-input" class="col-3 col-form-label">Name:</label>
		<div class="col-9">
			<input class="form-control m-input" type="text" [ngModel]="data.trainerObj?.name" readonly [ngModelOptions]="{standalone: true}"
			 id="example-text-input">
		</div>
		</div>
		<div class="form-group m-form__group row">
			<label for="example-search-input" class="col-3 col-form-label">Mobile Number:</label>
			<div class="col-9">
				<input class="form-control m-input" type="text" [ngModel]="data.trainerObj?.phone" readonly [ngModelOptions]="{standalone: true}"
			 id="example-search-input">
		</div>
			</div>
			<div class="form-group m-form__group row">
				<label for="example-email-input" class="col-3 col-form-label">Minimum Education Qualification:</label>
				<div class="col-9">
					<input class="form-control m-input" type="text" [ngModel]="data.trainerObj?.education?data.trainerObj?.education[0]?.education?.eduQualDesc:''"
			 readonly [ngModelOptions]="{standalone: true}" id="example-email-input">
		</div>
				</div>
				<!-- <div class="form-group m-form__group row">
		<label for="example-url-input" class="col-3 col-form-label">Trainer Certified in Entrepreneurship by NIESBUD or Similar Agency:</label>
		<div class="col-9">
			<input class="form-control m-input" type="text" [ngModel]="isEntreprenerShipCertified(data.trainerObj?.entrepreneurshipCertification)"
			 readonly [ngModelOptions]="{standalone: true}" id="example-url-input">
		</div>
	</div> -->
				<div class="form-group m-form__group row">
					<label for="example-url-input" class="col-3 col-form-label">Is Trainer Certified by Awarding Body:</label>
					<div class="col-9">
						<input class="form-control m-input" type="text" [ngModel]="isCertified" readonly [ngModelOptions]="{standalone: true}" id="example-url-input">
		</div>
					</div>
					<div class="form-group m-form__group row">
						<label for="example-url-input" class="col-3 col-form-label">Download Trainer Certificate:</label>
						<div class="col-9">
							<b *ngIf="isCertified === 'Yes'" class="document_link m--font-info download-link" (click)="downloadCertificate()">Download Certificate</b>
							<b *ngIf="isCertified === 'No'" class="document_link">Nill</b>
						</div>
					</div>
					<!-- <div class="form-group m-form__group row">
		<label for="example-tel-input" class="col-3 col-form-label">Agency Name from where Entrepreneurship certificate Obtained:</label>
		<div class="col-9">
			<input class="form-control m-input" type="text" [ngModel]="data.trainerObj?.entrepreneurshipCertification?.agencyName" readonly
			 [ngModelOptions]="{standalone: true}" id="example-url-input">

		</div>
	</div> -->
					<div class="form-group m-form__group row">
						<label for="example-password-input" class="col-3 col-form-label">Type of Resource:</label>
						<div class="col-9">
							<input class="form-control m-input" type="text" [ngModel]="typeOfResource?typeOfResource:data.trainerObj?.resourcetype" readonly [ngModelOptions]="{standalone: true}"
			 id="example-password-input">
		</div>
						</div>
						<div class="form-group m-form__group row">
							<label for="example-number-input" class="col-12 col-form-label text-center" style="font-weight: bold">Sector Related Experience:</label>
							<div class="col-9">

							</div>
							<div class="col-12">
								<table style="width:100%;">
									<thead>
										<th class="td-experiance">Sector</th>
										<th class="td-experiance">Year</th>
										<th class="td-experiance">Month</th>
									</thead>
									<tbody *ngFor="let industrial of data?.trainerObj?.industrialExperience">
										<td class="td-experiance">{{industrial?.sector?.sector}}</td>
										<td class="td-experiance">{{industrial?.totalExperience?.years}}</td>
										<td class="td-experiance">{{industrial?.totalExperience?.months}}</td>
									</tbody>
								</table>
							</div>
						</div>
						<div class="form-group m-form__group row">
							<label for="example-datetime-local-input" class="col-12 col-form-label text-center" style="font-weight: bold">Teaching Related Experience:</label>
							<div class="col-9">
							</div>
							<div class="col-12">
								<table style="width:100%;">
									<thead>
										<th class="td-experiance">Sector</th>
										<th class="td-experiance">Year</th>
										<th class="td-experiance">Month</th>
									</thead>
									<tbody *ngFor="let industrial of data?.trainerObj?.trainingExperience">
										<td class="td-experiance">{{industrial?.sector?.sector}}</td>
										<td class="td-experiance">{{industrial?.totalExperience?.years}}</td>
										<td class="td-experiance">{{industrial?.totalExperience?.months}}</td>
									</tbody>
								</table>
							</div>
						</div>
					</div>
